import { render, staticRenderFns } from "./InsuranceReviewCard.vue?vue&type=template&id=5e23bcc3"
import script from "./InsuranceReviewCard.vue?vue&type=script&lang=js"
export * from "./InsuranceReviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports